// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-new-delivery-address {
  height: 90vh;
  max-width: 100%;
  padding: var(--spacing-regular);
}
.modal-new-delivery-address .divider {
  border-color: #dce2f0;
}
.modal-new-delivery-address .vert-icon svg {
  width: var(--font-giant);
  height: var(--font-giant);
}
.modal-new-delivery-address .modal-new-delivery-address-title {
  display: flex;
  align-items: center;
}
.modal-new-delivery-address .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px;
  margin: 0 0 0 16px;
}
.modal-new-delivery-address .modal-new-delivery-address-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.modal-new-delivery-address .modal-new-delivery-address-content .subtittle {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/ModalNewDeliveryAddressStyles.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,+BAAA;AACF;AAJA;EAKI,qBAAA;AAEJ;AAPA;EAUI,wBAAA;EACA,yBAAA;AAAJ;AAXA;EAeI,aAAA;EACA,mBAAA;AADJ;AAfA;EAmBI,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;AArBA;EA0BI,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AA1BA;EA8BM,gCAAA;EACA,gBAAA;EACA,iBAAA;AADN","sourcesContent":[".modal-new-delivery-address {\n  height: 90vh;\n  max-width: 100%;\n  padding: var(--spacing-regular);\n  .divider {\n    border-color: #dce2f0;\n    // margin: var(--spacing-small) 0;\n  }\n\n  .vert-icon svg {\n    width: var(--font-giant);\n    height: var(--font-giant);\n  }\n\n  .modal-new-delivery-address-title {\n    display: flex;\n    align-items: center;\n  }\n  .vert-title {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    line-height: 24px;\n    margin: 0 0 0 16px;\n  }\n\n  .modal-new-delivery-address-content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    .subtittle {\n      font-size: var(--font-paragraph);\n      font-weight: 400;\n      line-height: 20px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
